const USER_INFO = "step_user_info";
const HIDE_IE_TIP = "hide_ie_tip";
const CAPTCHA = "step_captcha";
const storage = window.localStorage;
let userInfo = null;
let authList;
export default {
    IETipSet() {
        storage.setItem(HIDE_IE_TIP, "1");
    },
    IETipGet() {
        return storage.getItem(HIDE_IE_TIP) || "0";
    },
    login(obj) {
        storage.setItem(USER_INFO, JSON.stringify(obj));
        userInfo = obj;
    },
    logout() {
        userInfo = null;
        storage.setItem(USER_INFO, null);
        storage.clear();
    },
    isLogin() {
        return !!this.getToken();
    },
    getUserInfo() {
        if (!userInfo) {
            userInfo = JSON.parse(storage.getItem(USER_INFO));
            console.log(userInfo);
        }
        return userInfo || {};
    },
    getToken() {
        return this.getUserInfo().token;
    },
    getUserId() {
        return this.getUserInfo().userId;
    },
    getUserName() {
        return this.getUserInfo().userName;
    },
    getDepartmentName() {
        return this.getUserInfo().departmentName;
    },
    getName() {
        return this.getUserInfo().name;
    },
    getAuth() {
        return this.getUserInfo().navItemList;
    },
    getAuthString() {
        return this.getUserInfo().userAuthority;
    },
    hasAuth(functionID) {
        try {
            authList = this.getUserInfo().navItemList;
             for(let item of authList) {
                 if(item.functionID ===functionID) {
                     return true;
                 }
             }
        } catch (e) {
            console.error(e);
            return false;
        }
    },
    getUserType() {
        return this.getUserInfo().userType;
    },
    getLoginType() {
        return this.getUserInfo().loginType;
    },
    isShowCaptcha() {
        return storage.getItem(CAPTCHA) === "true";
    },
    showCaptcha() {
        storage.setItem(CAPTCHA, "true");
    },
    hideCaptcha() {
        storage.setItem(CAPTCHA, "false");
    },
};
